import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';

import MaterialTable from 'material-table'

import ItemBuilderDialog from './ItemBuilderDialog';
import ConfirmDialog from '../ConfirmDialog';


const tableRef = React.createRef();

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
}));

const MaterialTableTable = (props) => {
    const classes = useStyles();

    const [currentItem, setCurrentItem] = React.useState(null);

    const [itemDialogOpen, setItemDialogOpen] = React.useState(false);
    const handleItemDialogClose = () => {
        setItemDialogOpen(false);
    }

    const displayEditItem = rowData => {
        setCurrentItem(rowData);
        setItemDialogOpen(true);
    }

    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const [openDeleteDialog, setDeleteDialogOpen] = React.useState(false);
    const handleDeleteClose = action => () => {
        if (action == 'agree') {
            deleteItem(currentItem.item_id).then(() => {
                setSnackbarMessage('Successfully deleted item');
                setOpenSnackbar(true);
                tableRef.current.onQueryChange();
            });
        }
        setDeleteDialogOpen(false);
    };

    const handleDelete = rowData => {
        setCurrentItem(rowData);
        setDeleteDialogOpen(true);
    }

    const deleteItem = id => {
        const data = {
            _token: window._token
        }
        return new Promise((resolve, reject) => {
            fetch(`/api/admin/ceremony/templates/items/${id}`, {
                method: 'DELETE',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setDeleteDialogOpen(false);
                    resolve();
                })
                .catch(reason => {
                    setDeleteDialogOpen(false);
                    alert('An error prevented deleting the item. Please refresh the page and try again.');
                    reject();
                })
        });
    }

    const formatNumber = number => {
        return (number !== '' && number !== undefined) ? parseFloat(number).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        }) : '';
    }

    const [state, setState] = React.useState({
        columns: [
            { title: 'Name', field: 'item_name', filtering: false, sorting: false, width: 200 },
            { title: 'Text', field: 'item_text', filtering: false, sorting: false, width: 500 },
            { title: 'Section', field: 'section_name', filtering: false, sorting: false },
            { title: 'Category', field: 'category_name', filtering: false, sorting: false },
            { title: 'Order', field: 'item_order', filtering: false, sorting: false },
            { title: 'Item Status', field: 'item_status', filtering: false, sorting: false },
            { title: 'Section Status', field: 'section_status', filtering: false, sorting: false }
        ],
    });

    const pageSizeOptions = [30, 50, 100, 250];
    const [resultTotal, setResultTotal] = React.useState(0);
    const filteredPageSizeOptions = total => total > 0 ? pageSizeOptions : [0];

    const [isActiveFilter, setIsActiveFilter] = React.useState(true);
    const handleIsActiveChange = event => {
        setIsActiveFilter(event.target.checked);
        if (tableRef.current) {
            const query = tableRef.current.state.query;
            query.page = 0;
            query.is_active = isActiveFilter;
            tableRef.current.onQueryChange();
        }
    }

    const handleItemDialogSave = () => {
        tableRef.current && tableRef.current.onQueryChange()
    }

    const fetchData = query =>
        new Promise((resolve, reject) => {
            let url = '/api/admin/ceremony/templates/items?';

            /* TOOD: find better way to do this */
            query.is_active = isActiveFilter;
            query.orderBy = query.orderBy ? query.orderBy : { field: 'wedding_date' };

            /* TODO: use orderBy and filters */
            url += 'per_page=' + query.pageSize;
            url += '&page=' + (query.page + 1);
            url += '&search=' + query.search;
            url += '&orderBy=' + (query.orderBy ? query.orderBy.field : '');
            url += '&orderDirection=' + (query.orderDirection ? query.orderDirection : 'asc');
            url += '&is_active=' + query.is_active;
            if (query.filters.length) {
                url += '&' + query.filters.map(x => `${x.column.field}=`+encodeURI(x.value)).join('&')
            }
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setResultTotal(result.total);
                    resolve({
                        data: result.data,
                        page: result.current_page - 1,
                        totalCount: result.total,
                    })
                })
            }
        )

    const defaultSearchText = '';

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box component="span" style={{marginLeft: -10}}>
                    <Switch id="is-active-filter" checked={isActiveFilter} onChange={handleIsActiveChange} title="Is Active" color="primary" />
                </Box>
               <Typography component="label" className="MuiFormLabel-root MuiInputLabel-shrink">
                   {isActiveFilter ? 'All items' : 'Inactive items'}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <MaterialTable
                    title="Ceremonial Elements"
                    columns={state.columns}
                    data={fetchData}
                    actions={[
                        {
                            icon: 'edit',
                            tooltip: 'Edit Item',
                            onClick: (event, rowData) => {
                                displayEditItem(rowData);
                            }
                        },
                        {
                            icon: 'delete',
                            tooltip: 'Delete Item',
                            onClick: (event, rowData) => {
                                handleDelete(rowData);
                            }
                        },
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                        }
                    ].filter(x => x !== null)}
                    components={{
                        Container: Box,
                    }}
                    options={{
                        showTitle: false,
                        pageSize: 50,
                        pageSizeOptions: filteredPageSizeOptions(resultTotal),
                        exportButton: true,
                        loadingType: 'linear',
                        emptyRowsWhenPaging: false,
                        filtering: true,
                        sorting: true,
                        debounceInterval: 600,
                        padding: 'dense',
                        searchText: defaultSearchText,
                    }}
                    tableRef={tableRef}
                />
                <ConfirmDialog
                    title="Confirm delete"
                    text="Are you sure you wish to delete this item?"
                    agreeText="Delete"
                    declineText="Cancel"
                    handleClose={handleDeleteClose}
                    open={openDeleteDialog}
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={openSnackbar}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    message={snackbarMessage}
                    action={
                        <React.Fragment>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </React.Fragment>
                    }
                />
                <ItemBuilderDialog open={itemDialogOpen} handleClose={handleItemDialogClose} scroll='paper' handleSave={handleItemDialogSave} item={currentItem} />
            </Grid>
        </Grid>
    );
};

const CeremonyTemplatesList = (props) => {
    const classes = useStyles();

    useEffect(() => {
        document.title = 'Ceremony Templates List - Enduring Promises';
    }, []);

    return (
        <Paper square className={classes.paper}>
            <div style={{ maxWidth: '100%' }}>
                <Typography variant="h6">Ceremonial Elements</Typography>
                <MaterialTableTable />
            </div>
        </Paper>
    );
}

export default CeremonyTemplatesList;
